import { gql } from "@apollo/client";

export default gql`
  query getAllAiKnowledgeSourceContent($data: GetAiKnowledgeSourceContentInput!){
    getAllAiKnowledgeSourceContent(data: $data){
        success
        data{
            docs{
                _id
                aiProfile
                aiKnowledgeSource
                status
                source
                language
                content
                title
                chunkNumber
                sourceType
                knowledgeScope
                scopeType
                scopeRef
                questionHash
                contentHash
                createdAt
                updatedAt
                failedReason
            }
            totalDocs
            hasPrevPage
            hasNextPage
        }
        code
        message
    }
}
`
